import React, { useState } from "react";
import { FaTimes, FaCamera } from "react-icons/fa";

export default function UserCapteurList({ linkedCapteurs, onRemove }) {
  const [confirmingId, setConfirmingId] = useState(null);
  const [removingId, setRemovingId] = useState(null);

  const handleConfirmRemove = async (capteurId) => {
    setRemovingId(capteurId);
    try {
      await onRemove(capteurId);
    } finally {
      setRemovingId(null);
      setConfirmingId(null);
    }
  };

  return (
    <div>
      <p className="text-sm font-medium text-gray-600 mb-3">
        Compteurs liés à cet utilisateur
      </p>
      {linkedCapteurs.length === 0 ? (
        <div className="bg-gray-50 rounded-xl px-4 py-3 text-sm text-gray-400 text-center">
          Aucun compteur associé pour le moment.
        </div>
      ) : (
        <ul className="space-y-2">
          {linkedCapteurs.map((capteur) => (
            <li
              key={capteur._id}
              className="bg-gray-50 border border-gray-200 rounded-lg overflow-hidden"
            >
              {confirmingId === capteur._id ? (
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 bg-red-50 px-4 py-3">
                  <p className="text-xs sm:text-sm text-red-700 font-medium">
                    Retirer « {capteur.nom_camera || 'ce compteur'} » de cet utilisateur ?
                  </p>
                  <div className="flex gap-2 shrink-0">
                    <button
                      onClick={() => handleConfirmRemove(capteur._id)}
                      disabled={removingId === capteur._id}
                      className="bg-red-500 text-white px-3 py-1.5 rounded-lg text-xs sm:text-sm font-medium hover:bg-red-600 transition-colors disabled:opacity-50"
                    >
                      {removingId === capteur._id ? 'Retrait...' : 'Confirmer'}
                    </button>
                    <button
                      onClick={() => setConfirmingId(null)}
                      disabled={removingId === capteur._id}
                      className="bg-white border border-gray-300 text-gray-600 px-3 py-1.5 rounded-lg text-xs sm:text-sm font-medium hover:bg-gray-100 transition-colors disabled:opacity-50"
                    >
                      Annuler
                    </button>
                  </div>
                </div>
              ) : (
                <div className="flex items-center justify-between gap-3 px-4 py-3">
                  <span className="flex items-center gap-2 text-sm font-medium text-gray-700 truncate">
                    <FaCamera className="text-gray-400 shrink-0" />
                    {capteur.nom_camera || 'Sans nom'}
                  </span>
                  <button
                    onClick={() => setConfirmingId(capteur._id)}
                    className="flex items-center gap-1 text-xs sm:text-sm text-red-500 hover:text-red-700 font-medium shrink-0"
                  >
                    <FaTimes />
                    Retirer
                  </button>
                </div>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}